import { ExternalCostDto, ProjectCicloPassivoOutputDto, ProjectExternalCost } from '@api/client';
import { InputNumber } from 'antd';
import { ChangeEvent, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FormBootstrap from 'react-bootstrap/Form';

interface Props {
  project: ProjectExternalCost;
  handleChangeAssociated: (
    e: ChangeEvent<HTMLInputElement>,
    cost: ExternalCostDto,
    project: ProjectCicloPassivoOutputDto
  ) => void;
  handleChangeAmount: (e: number | undefined, cost: ExternalCostDto, project: ProjectCicloPassivoOutputDto) => void;
}

const PassiveCycleAssociableProjectsToBill: React.FC<Props> = ({
  project,
  handleChangeAssociated,
  handleChangeAmount,
}) => {
  const { t } = useTranslation();
  const [showExternalCosts, setShowExternalCosts] = useState<boolean>(false);
  const [originalProject, setOriginalProject] = useState<ProjectCicloPassivoOutputDto | undefined>(undefined);

  useEffect(() => {
    if (!originalProject) {
      setOriginalProject(project);
    }
  }, [originalProject, project]);

  return (
    <Card className="mb-3">
      <Card.Body>
        <div className="dflex flex-column">
          <div className="d-flex justify-content-between" style={{ maxHeight: '25px' }}>
            <h6 className="fw-bold align-content-center">{`${project.projectId} (${project.intranetId}) - ${project.projectName}`}</h6>

            <button
              className="download btn btn-sm btn-links-no-border d-flex align-items-top p-0"
              onClick={() => setShowExternalCosts(!showExternalCosts)}
            >
              <p className="text-blue-links fw-bold">
                {showExternalCosts ? t('Hide external costs') : t('Show external costs >')}
              </p>
            </button>
          </div>
          {showExternalCosts && (
            <div className="mt-4">
              <div className="row">
                {project.externalCosts?.map((cost: ExternalCostDto, index: number) => (
                  <div key={index} className="col-6 d-flex justify-content-between align-items-center mb-3">
                    <div className="col-9 d-flex align-items-center">
                      <FormBootstrap.Check
                        type={'checkbox'}
                        checked={cost.isAssociated}
                        disabled={originalProject?.otherCostList?.otherCosts?.[index].isAssociated}
                        onChange={(e) => handleChangeAssociated(e, cost, project)}
                      />
                      <label className="w-100 ms-2 me-4">
                        {t(`project-detail.cost-type-id-${cost.costType?.id}`)}
                        <br />
                        <span className="text-placeholder">{cost.description || 'No description avaiable'}</span>
                      </label>
                    </div>
                    <div className=" col-3 input-num-wrapper d-flex flex-column">
                      <label className="w-100">{t(`Amount`)}</label>
                      <InputNumber
                        type="number"
                        className="w-100"
                        placeholder={t('Insert amount')}
                        min={0}
                        step="0.01"
                        value={cost.contractAmount}
                        onChange={(e) => handleChangeAmount(e as number | undefined, cost, project)}
                        size="middle"
                        suffix={'€'}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default PassiveCycleAssociableProjectsToBill;
